export interface IRccapReportDetail {
    id: number,
    responsibleCenterId: number,
    failDate: string,
    responseDate: string,
    donorCenterId: number,
    donorCenter: string,
    rdnCenterId: number,
    rdnCenter: string,
    recipientCenterId: number,
    recipientCenter: string,
    swapNumber: string,
    swapManager: string,
    status: string,
    transplants: number,
    type: string,
    billable: number
}